import { c as _c } from "react/compiler-runtime";
import type { Entry } from "contentful";
import { getEntryOfContentType } from "@/lib/contentful/guards";
import type { TypeDuplexSkeleton, TypeEmailFormSkeleton, TypeProseSkeleton, TypeSpecsSkeleton } from "@/types/contentful/generated";
import Duplex from "../Duplex";
import { EmailForm } from "../EmailForm/EmailForm";
import { Prose } from "../Prose";
import Specs from "../Specs";
type DuplexEntry = Entry<TypeDuplexSkeleton, undefined, string>;
type EmailFormEntry = Entry<TypeEmailFormSkeleton, undefined, string>;
type ProseEntry = Entry<TypeProseSkeleton, undefined, string>;
type SpecsEntry = Entry<TypeSpecsSkeleton, undefined, string>;
type ContentBlock = Entry<TypeDuplexSkeleton | TypeEmailFormSkeleton | TypeProseSkeleton | TypeSpecsSkeleton, undefined, string>;
interface Props {
  block: ContentBlock;
}
export function AccordionContentBlock(t0) {
  const $ = _c(16);
  const {
    block
  } = t0;
  let t1;
  if ($[0] !== block) {
    t1 = getEntryOfContentType(block, "duplex");
    $[0] = block;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const duplex = t1;
  if (duplex) {
    let t2;
    if ($[2] !== duplex.fields) {
      t2 = <Duplex {...duplex.fields} />;
      $[2] = duplex.fields;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  let t2;
  if ($[4] !== block) {
    t2 = getEntryOfContentType(block, "emailForm");
    $[4] = block;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const emailForm = t2;
  if (emailForm) {
    let t3;
    if ($[6] !== emailForm.fields) {
      t3 = <EmailForm {...emailForm.fields} />;
      $[6] = emailForm.fields;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    return t3;
  }
  let t3;
  if ($[8] !== block) {
    t3 = getEntryOfContentType(block, "prose");
    $[8] = block;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const prose = t3;
  if (prose) {
    let t4;
    if ($[10] !== prose.fields.content) {
      t4 = <Prose content={prose.fields.content} />;
      $[10] = prose.fields.content;
      $[11] = t4;
    } else {
      t4 = $[11];
    }
    return t4;
  }
  let t4;
  if ($[12] !== block) {
    t4 = getEntryOfContentType(block, "specs");
    $[12] = block;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  const specs = t4;
  if (specs) {
    let t5;
    if ($[14] !== specs.fields) {
      t5 = <Specs {...specs.fields} />;
      $[14] = specs.fields;
      $[15] = t5;
    } else {
      t5 = $[15];
    }
    return t5;
  }
  return null;
}